/**
 * Agents RTK Query tag-type registry.
 *
 * All tag types are declared up-front here and passed to the single base `createApi`
 * (see `agentsApi.ts`). `injectEndpoints` cannot introduce new tag types, so any tag a
 * feature endpoint provides/invalidates MUST be listed here. Centralizing the registry is
 * what lets a mutation in one feature invalidate a query in another — that cross-feature
 * cache invalidation only works because every feature shares this one tag space.
 */
export const AGENT_TAG_TYPES = [
  'AgentCatalog',
  'AgentDetail',
  'AgentHealth',
  'AgentRuns',
  'AgentThroughput',
  'StepRecipe',
] as const;

export type AgentTagType = (typeof AGENT_TAG_TYPES)[number];
